import styled from 'styled-components';

export const Separator = styled.hr`
  ${({ theme }): string => theme.mixins.margin({ bottom: 2 })};
  color: ${({ theme }) => theme.commons.colors.gray200};
  border-top: 1px solid #d1d7d7;
  border-radius: 1px;
`;
